import { FiscalYearSemester, periodType, weekdayKey } from '@/store/common.types'
import { Deadline, DeadlineWaitingApproved } from '@/store/deadlines/types'
import { Moment } from 'moment';
import { Application } from '@/store/applications/types'
import { Booth } from '../booths/types';
import { Campus, Level, University } from '../master/types';
import { scheduleType } from '../schedules/types';

export const LessonScheduleTermTypes = {
  week: 'Week',
  month: 'Month',
}
export type lessonScheduleTermType = keyof typeof LessonScheduleTermTypes

export interface MypageState {
  lessonSchedules: LessonSchedule[],
  lessons: Lesson[],
  informations: Information[],
  toDoApplications: Application[],
  toDoWaitingApproveds: DeadlineWaitingApproved[],
  toDoDeadlines: Deadline[]
  events: Event[],
  announces: Announce[],
}

export interface TutorLessonScheduleConditions {
  month?: Moment
  week?: Moment
  university?: University
}

export interface LessonSchedule {
  scheduleId: string
  date: Moment
  period: periodType
  unit: number|null
  type: scheduleType
  university: University
  campus: Campus
  booth: Booth|null
  course: {
    code: string
    name: string
  }|null
  level: Level|null
}

export interface Lesson {
  id: string,
  date: number,
  period: number,
  type: string,
  unit: number,
  universityName: string,
  universityAbbreviation: string,
  campusName: string,
  campusAbbreviation: string,
  boothBuilding: string,
  boothRoom: string,
  boothNumber: number,
  scheduleId: string,
  courseCode: string,
  courseName: string,
  levelName: string,
  students: Student[],
}

export interface Student {
  studentName: string,
}

export interface Information {
  notificationId: string,
  sendDate: number,
  subject: string,
  sendStatusName: string
}

export interface Announce {
  notificationId: string,
  sendDate: number,
  subject: string,
  sendStatusName: string
}

export interface Event {
  id: string,
  type: string,
  date: number,
  startTime: string,
  endTime: string,
  tutorId: string
}
